import gql from 'graphql-tag';
import graphqlClient from '@/shared/graphql/client-company';

export class CompanyService {
  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMPANY_CREATE($data: CompanyInput!) {
          companyCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.companyCreate;
  }

  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMPANY_UPDATE(
          $id: String!
          $data: CompanyInput!
        ) {
          companyUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.companyUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMPANY_DESTROY($ids: [String!]!) {
          companyDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.companyDestroy;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMPANY_IMPORT(
          $data: CompanyInput!
          $importHash: String!
        ) {
          companyImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.companyImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query COMPANY_FIND($id: String!) {
          companyFind(id: $id) {
            id
            name {
              en
              ar
            }
            description {
              en
              ar
            }
            address {
              en
              ar
            }
            logo {
              name
              publicUrl
            }
            commercialRegister {
              name
              publicUrl
            }
            license {
              name
              publicUrl
            }
            email
            websiteLink
            facebookLink
            twitterLink
            instagramLink
            phoneNumber
            countryCode
            legalAuthority
            rate
            languages
            wallet
            status
            rejectionReason
            disabled
            countryId
            cityId
            
            branches {
              id
            }
            guides {
              id
            }
            reviews {
              id
              rate
              description
              reviewer {
                avatar {
                  name
                  publicUrl
                }
                fullName
                email
                phoneNumber
              }
              createdBy
              createdAt
            }

            createdBy
            updatedBy
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.companyFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query COMPANY_LIST(
          $filter: CompanyFilterInput
          $orderBy: CompanyOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          companyList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              name {
                en
                ar
              }
              description {
                en
                ar
              }
              address {
                en
                ar
              }
              logo {
                name
                publicUrl
              }
              commercialRegister {
                name
                publicUrl
              }
              license {
                name
                publicUrl
              }
              email
              websiteLink
              facebookLink
              twitterLink
              instagramLink
              phoneNumber
              countryCode
              legalAuthority
              rate
              languages
              wallet
              status
              rejectionReason
              disabled
              countryId
              cityId
              
              branches {
                id
              }
              guides {
                id
              }
              reviews {
                id
                rate
                description
                reviewer {
                  avatar {
                    name
                    publicUrl
                  }
                  fullName
                  email
                  phoneNumber
                }
                createdBy
                createdAt
              }

              createdBy
              updatedBy
              createdAt
              updatedAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.companyList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query COMPANY_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          companyAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.companyAutocomplete;
  }
}
